<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-window', fontSet: 'fad'}"
	[headerText]="T.PANEL_CONFIGURATION_DIALOG_HEADER | translate"
	[matDialogData]="data"
	[rect]="rect"
	class="normalDuotoneHeaderIcon"
>
	<ng-container dialogContent>
		<div (cdkDropListDropped)="orderPanel($event)" cdkDropList class="panelContainer">
			@for (panel of data.panels; track panel) {
				<div cdkDrag cdkDragBoundary=".panelContainer" class="panel panelConfigurationDialogPanel">
					<div class="panelIcon">
						<i class="{{ panel.fontSet + ' ' }}{{ panel.icon }}"> </i>
					</div>
					<div class="panelTitle">
						{{ panel.type | enumLabel: EnumLabel.ControlPanelHeader }}
					</div>
					<div class="panelActions">
						<button
							(click)="togglePanelHiddenClicked(panel)"
							[matTooltipPosition]="'left'"
							[matTooltip]="
								(panel?.isHidden ? T.PANEL_CONFIGURATION_DIALOG_SHOW_PANEL : T.PANEL_CONFIGURATION_DIALOG_HIDE_PANEL)
									| translate
							"
							color="accent"
							mat-icon-button
							matTooltipClass="accent"
						>
							<sim-animated-material-icon
								[trigger]="panel?.isHidden"
								[biggerFAIcon]="true"
								[endIcon]="{
									fontSet: 'fad',
									fontIcon: 'fa-eye-slash',
								}"
								[startIcon]="{
									fontSet: 'fad',
									fontIcon: 'fa-eye',
									themeColor: 'accent',
								}"
							/>
						</button>
						<button cdkDragHandle color="accent" mat-icon-button>
							<mat-icon fontIcon="fa-grip-lines" fontSet="fa" inline />
						</button>
					</div>
				</div>
			}
		</div>
	</ng-container>

	<ng-container actions>
		@if (
			isTwoScreen ||
			data.controlPanelLocation === ControlPanelLocation.Tablet ||
			data.controlPanelLocation === ControlPanelLocation.ParticipationView
		) {
			<button (click)="dockAllPanels()" class="margin-right-auto" color="accent" mat-button>
				<mat-icon fontIcon="fa-window-restore" fontSet="fad" style="margin-top: 10px" />
				{{ T.PANEL_CONFIGURATION_DIALOG_RESTORE_BUTTON_TEXT | translate }}
			</button>
		}

		<sim-button
			(onClick)="close()"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
			[label]="T.CONFIGURATION_EDITOR_AUDIO_OK"
			color="accent"
		/>
	</ng-container>
</sim-basic-material-dialog>
